<template>
  <v-app>
    <LayoutHeader v-if="showHeader" class="layout--header" />
    <LayoutContent class="layout--content" />
  </v-app>
</template>

<script>
import LayoutContent from './LayoutContent.vue';
import LayoutHeader from './LayoutHeader.vue';

export default {
  components: {
    LayoutContent,
    LayoutHeader,
  },
  computed: {
    showHeader() {
      if (!this.$route || !this.$route.meta) {
        return true;
      }
      return typeof this.$route.meta.showHeader === 'boolean'
        ? this.$route.meta.showHeader
        : true;
    },
  },
};
</script>

<style lang="scss">
.layout {
  &--content {
    position: relative;
    z-index: 1;
  }

  &--header {
    position: relative;
    z-index: 2;
  }
}
</style>
